// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3HXAG","addWidgetButton":"Header_addWidgetButton__F1fUv","dashboardTabs":"Header_dashboardTabs__3t5LK","active":"Header_active__1RReI"};